import { FETCH_SET_GLOBAL_MESSAGE } from '../../types/types'

export const setGlobalMessage = (messages) => ({
  type: FETCH_SET_GLOBAL_MESSAGE,
  payload: { messages },
})
